module.exports = __webpack_public_path__ + "static/banner1-d452f99bfb1132f4d75f7f903105458e.jpg";